import React from "react"
import Svg from "../../shared/_svgs/svg"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import ReactHtmlParser from "react-html-parser"
import useWindowWidth from "../../hooks/useWindowWidth"

export default function InfoBanner(props) {
  const windowWidth = useWindowWidth()

  //SVG background and SVG color
  const iconBackgroundColor = SelectionFactoryHelper.getFromSelectionFactory(props.backgroundColor)
  const svgIconColor = SelectionFactoryHelper.getFromSelectionFactory(props.svgIconColor)

  const svgColor = svgIconColor === "cph-corp-blue" ? "#071143" : "#FFF"

  //Text area background and Font color
  const textBackgroundColor = SelectionFactoryHelper.getFromSelectionFactory(props.textBackgroundColor)
  const fontColor = SelectionFactoryHelper.getFromSelectionFactory(props.textAndIconColor)

  const svgIcon = SelectionFactoryHelper.getFromSelectionFactory(props.svgIcon)
  const hasIcon = !!props.iconUpload || svgIcon !== "None"
  const target = props.linkTarget[0]?.value || "_blank"

  return (
    <div className="infobanner-container">
      {windowWidth >= 950 ? ( //desktop
        <div className={`w--wider infobanner-block ${iconBackgroundColor ? iconBackgroundColor : ""}`}>
          <a data-epi-property="Link" href={props.link} target={target}>
            <div className="infobanner-inner">
              {!hasIcon ? (
                ""
              ) : (
                <div className={`iconarea ${iconBackgroundColor ? iconBackgroundColor : ""}`}>
                  {props.iconUpload ? (
                    <div className={"icon"}>
                      <img data-epi-property="IconUpload" className="icon-upload" src={props.iconUpload} />
                    </div>
                  ) : (
                    <Svg iconName={svgIcon} stroke={svgColor} fillColor={"transparent"} />
                  )}
                </div>
              )}
              <div className={`textarea ${textBackgroundColor ? textBackgroundColor : "casc-white"}`}>
                <div className={`leftarea ${fontColor ? fontColor : ""}`}>
                  <h5 data-epi-property="Headline">{props.headline}</h5>
                  <span data-epi-property="SubHeadline" className={"icon-container"}>
                    <Svg iconName={"icon_arrowright_new"} stroke={props.textAndIconColor ?? "#FFF"} fillColor={"none"} renderContainer={false} />
                    {props.subHeadline}
                  </span>
                </div>
                <div data-epi-property="RichText" className="rightarea">
                  {ReactHtmlParser(props.richText)}
                </div>
              </div>
            </div>
          </a>
        </div>
      ) : (
        //mobile / tablet
        <div className="w--wider infobanner-block">
          <a data-epi-property="Link" href={props.link} target={target}>
            <div className="infobanner-inner">
              <div className="textarea casc-blue">
                <div className="leftarea cph-white">
                  <h5 data-epi-property="Headline">{props.headline}</h5>
                  <span data-epi-property="Subheadline" className="icon-container">
                    <Svg iconName={"icon_arrowright_new"} stroke={"#FFF"} fillColor={"transparent"} renderContainer={false} />
                    {props.subHeadline}
                  </span>
                </div>
              </div>
            </div>
          </a>
        </div>
      )}
    </div>
  )
}
